import { render, staticRenderFns } from "./DirectInput.vue?vue&type=template&id=24cf4224"
import script from "./DirectInput.vue?vue&type=script&lang=js"
export * from "./DirectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports